import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "false",
  "data-keyboard": "false",
  id: "signaturePadModal",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Create Signature "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "create signature")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "signature-wrap border p-2 rounded mb-3"
}
const _hoisted_9 = {
  ref: "wrapper",
  id: "signature-pad",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_10 = { ref: "canvas" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "my-3" }, [
  /*#__PURE__*/_createVNode("strong", null, "Add your signature here")
], -1)
const _hoisted_12 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VuePictureCropper = _resolveComponent("VuePictureCropper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "custom-modal-dialog  modal-xl custom-modal-dialog-centered custom-modal-dialog-scrollable",
        style: _ctx.customModalStyle
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSignaturePadModal && _ctx.closeSignaturePadModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_6
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.state.data.isuplode && _ctx.state.data.uploadSignature)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("img", {
                    src: _ctx.state.data.uploadSignature,
                    alt: ""
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.isuplode && _ctx.state.data.newUploadImge)
              ? (_openBlock(), _createBlock(_component_VuePictureCropper, {
                  key: 1,
                  class: "border p-1 rounded mb-3",
                  boxStyle: {
                width: '98%',
                height: '98%',
                backgroundColor: '#f8f8f8',
                margin: '0',
              },
                  img: _ctx.state.data.newUploadImge,
                  options: {
                viewMode: 1,
                dragMode: 'crop',
                aspectRatio: 30 / 20,
              }
                }, null, 8, ["img"]))
              : _createCommentVNode("", true),
            (!_ctx.state.data.isuplode)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: [{
              'signature-area': true,
              'border': true,
              'p-2': true,
              'rounded': true,
              'bg-light': true,
              'mb-3': true,
              'error-field': _ctx.state.data.isEmpty
            }, "display: flex; justify-content: center; align-items: center; height: 100%;"]
                }, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("canvas", _hoisted_10, null, 512)
                  ], 512)
                ], 2))
              : _createCommentVNode("", true),
            _hoisted_11
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("button", {
              type: "button",
              class: "btn default-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadUSerSignature && _ctx.uploadUSerSignature(...args)))
            }, "Save"),
            _createVNode("button", {
              type: "button",
              class: "btn default-btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSignature && _ctx.clearSignature(...args)))
            }, "Clear All"),
            (!_ctx.state.data.isuplode)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.undoSignature && _ctx.undoSignature(...args)))
                }, "Undo"))
              : _createCommentVNode("", true),
            (_ctx.state.data.isuplode)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveSignature && _ctx.saveSignature(...args)))
                }, "Crop"))
              : _createCommentVNode("", true),
            (_ctx.state.data.isuplode)
              ? (_openBlock(), _createBlock("button", {
                  key: 2,
                  class: "btn default-btn",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearCrop && _ctx.clearCrop(...args)))
                }, "Clear Crop"))
              : _createCommentVNode("", true),
            _createVNode("button", {
              class: "btn red-btn",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeSignaturePadModal && _ctx.closeSignaturePadModal(...args)))
            }, " Cancel ")
          ])
        ])
      ], 4)
    ])
  ]))
}